import queryString from 'querystring';
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('TAG_MODERATIONS_CATEGORIES_MODE_TINDER').plugin(axiosPlugin, {template: "array"});
let fetchAction = redux.fetchActionGet();


export const TYPES = redux.types;

export const fetchCategoriesModeTinder = (query) => fetchAction(`/tag-moderations/categories?${queryString.stringify(query)}`);
export const resetCategoriesModeTinder = () => redux.actions.reset();

export const categoriesModeTinder = redux.reducer();
